/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { VirtualFurnitureReadAttributesFurnitureInventory } from './virtual-furniture-read-attributes-furniture-inventory';
/**
 * 
 * @export
 * @interface VirtualFurnitureReadAttributes
 */
export interface VirtualFurnitureReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    availabilityStatus?: VirtualFurnitureReadAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    furnitureType: VirtualFurnitureReadAttributesFurnitureTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof VirtualFurnitureReadAttributes
     */
    createdAt?: Date;
    /**
     * 
     * @type {Blob}
     * @memberof VirtualFurnitureReadAttributes
     */
    asset: Blob;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    height?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    length?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VirtualFurnitureReadAttributes
     */
    inventory?: number;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    description?: string;
    /**
     * 
     * @type {Blob}
     * @memberof VirtualFurnitureReadAttributes
     */
    thumbnail?: Blob | null;
    /**
     * 
     * @type {Date}
     * @memberof VirtualFurnitureReadAttributes
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    width?: string | null;
    /**
     * 
     * @type {Array<VirtualFurnitureReadAttributesFurnitureInventory>}
     * @memberof VirtualFurnitureReadAttributes
     */
    furnitureInventory?: Array<VirtualFurnitureReadAttributesFurnitureInventory>;
}

/**
    * @export
    * @enum {string}
    */
export enum VirtualFurnitureReadAttributesAvailabilityStatusEnum {
    Disabled = 'disabled',
    Private = 'private',
    Public = 'public'
}
/**
    * @export
    * @enum {string}
    */
export enum VirtualFurnitureReadAttributesFurnitureTypeEnum {
    Chair = 'chair',
    RoundedTable = 'rounded-table',
    SquareTable = 'square-table',
    CocktailTable = 'cocktail-table',
    BoardroomTable = 'boardroom-table'
}

